export default [{
		name: '2013年民政赛优秀奖',
		fileUrl: '/file/rongyu/2013年民政赛优秀奖1.JPG',
	}, {
		name: '2013年民政赛优秀奖',
		fileUrl: '/file/rongyu/2013年民政赛优秀奖2.JPG',
	}, {
		name: '2015年民政赛优秀组织奖',
		fileUrl: '/file/rongyu/2015年民政赛优秀组织奖.JPG',
	}, {
		name: '2016年民政赛二等奖',
		fileUrl: '/file/rongyu/2016年民政赛二等奖1.JPG',
	}, {
		name: '2016年民政赛二等奖',
		fileUrl: '/file/rongyu/2016年民政赛二等奖2.JPG',
	}, {
		name: '2016年民政赛二等奖',
		fileUrl: '/file/rongyu/2016年民政赛二等奖3.JPG',
	}, {
		name: '2016年民政赛三等奖',
		fileUrl: '/file/rongyu/2016年民政赛三等奖1.JPG',
	}, {
		name: '2016年民政赛三等奖',
		fileUrl: '/file/rongyu/2013年民政赛优秀奖2.JPG',
	},
	{
		name: '2016年民政赛优秀组织奖',
		fileUrl: '/file/rongyu/2016年民政赛优秀组织奖.JPG',
	},
	{
		name: '2017年民政赛二等奖',
		fileUrl: '/file/rongyu/2017年民政赛二等奖1.JPG',
	},
	{
		name: '2017年民政赛二等奖',
		fileUrl: '/file/rongyu/2017年民政赛二等奖2.JPG',
	},
	{
		name: '2017年民政赛二等奖',
		fileUrl: '/file/rongyu/2017年民政赛二等奖-刘燕.png',
	},
	{
		name: '2017年民政赛三等奖',
		fileUrl: '/file/rongyu/2017年民政赛三等奖1.JPG',
	},
	{
		name: '2017年民政赛三等奖',
		fileUrl: '/file/rongyu/2017年民政赛三等奖2.JPG',
	}, {
		name: '2017年民政赛优秀组织奖',
		fileUrl: '/file/rongyu/2017年民政赛优秀组织奖.JPG',
	}, {
		name: '2018年国赛三等奖',
		fileUrl: '/file/rongyu/2018年国赛三等奖.JPG',
	}, {
		name: '2018年省级优秀指导教师',
		fileUrl: '/file/rongyu/2018年省级优秀指导教师-褚江周.png',
	}, {
		name: '2018年省级优秀指导教师',
		fileUrl: '/file/rongyu/2018年省级优秀指导教师-刘燕.png',
	}, {
		name: '2018年省赛二等奖',
		fileUrl: '/file/rongyu/2018年省赛二等奖1.jpg',
	}, {
		name: '2018年省赛二等奖',
		fileUrl: '/file/rongyu/2018年省赛二等奖2.jpg',
	}, {
		name: '2018年省赛一等奖',
		fileUrl: '/file/rongyu/2018年省赛一等奖1.jpg',
	}, {
		name: '2018年省赛一等奖',
		fileUrl: '/file/rongyu/2018年省赛一等奖2.jpg',
	}, {
		name: '2019年国赛三等奖',
		fileUrl: '/file/rongyu/2019年国赛三等奖.jpg',
	}, {
		name: '2019年省级优秀指导教师',
		fileUrl: '/file/rongyu/2019年省级优秀指导教师-褚江周.png',
	}, {
		name: '2019年省级优秀指导教师',
		fileUrl: '/file/rongyu/2019年省级优秀指导教师-刘燕.png',
	}, {
		name: '2019年省赛二等奖',
		fileUrl: '/file/rongyu/2019年省赛二等奖1.jpg',
	}, {
		name: '2019年省赛二等奖',
		fileUrl: '/file/rongyu/2019年省赛二等奖2.jpg',
	}, {
		name: '2019年省赛一等奖',
		fileUrl: '/file/rongyu/2019年省赛一等奖1.jpg',
	}, {
		name: '2019年省赛一等奖',
		fileUrl: '/file/rongyu/2019年省赛一等奖2.jpg',
	}, {
		name: '2020年家政扶贫国赛铜奖',
		fileUrl: '/file/rongyu/2020年家政扶贫国赛铜奖.jpg',
	}, {
		name: '2020年省级优秀指导教师',
		fileUrl: '/file/rongyu/2020年省级优秀指导教师-刘燕.jpg',
	}, {
		name: '2020年省赛一等奖',
		fileUrl: '/file/rongyu/2020年省赛一等奖.jpg',
	}, {
		name: '2021年国赛三等奖',
		fileUrl: '/file/rongyu/2021年国赛三等奖.jpg',
	}, {
		name: '2022年国家级优秀指导教师',
		fileUrl: '/file/rongyu/2022年国家级优秀指导教师-刘燕.jpg',
	}, {
		name: '2022年国赛一等奖',
		fileUrl: '/file/rongyu/2022年国赛一等奖.jpg',
	}, {
		name: '2022年护理省赛三等奖',
		fileUrl: '/file/rongyu/2022年护理省赛三等奖.png',
	}, {
		name: '2022年护理省赛三等奖',
		fileUrl: '/file/rongyu/2022年护理省赛三等奖—曾山峰.png',
	}, {
		name: '2022年护理省赛三等奖',
		fileUrl: '/file/rongyu/2022年护理省赛三等奖—吕明珠.png',
	}, {
		name: '2022年健康与社会照护省赛三等奖',
		fileUrl: '/file/rongyu/2022年健康与社会照护省赛三等奖—易梦宇.png',
	}, {
		name: '2022年省级优秀指导教师',
		fileUrl: '/file/rongyu/2022年省级优秀指导教师—曾莉.png',
	}, {
		name: '2022年省级优秀指导教师',
		fileUrl: '/file/rongyu/2022年省级优秀指导教师—褚江周.png',
	}, {
		name: '2022年省赛二等奖',
		fileUrl: '/file/rongyu/2022年省赛二等奖—李婷.png',
	}, {
		name: '2022年省赛一等奖',
		fileUrl: '/file/rongyu/2022年省赛一等奖—李佳星.png',
	}, {
		name: '2022年省赛一等奖',
		fileUrl: '/file/rongyu/2022年省赛一等奖—杨翠玉.png',
	}, {
		name: '2022年省赛专家',
		fileUrl: '/file/rongyu/2022年省赛专家—刘燕.png',
	}, {
		name: '2022年省赛专家',
		fileUrl: '/file/rongyu/2022年省赛专家—宁玉蓉.png',
	}, {
		name: '国家级教学成果奖一等奖',
		fileUrl: '/file/rongyu/国家级教学成果奖一等奖.jpg',
	}, {
		name: '教师教学能力大赛国赛二等奖',
		fileUrl: '/file/rongyu/教师教学能力大赛国赛二等奖.jpg',
	}, {
		name: '教师教学能力国家级三等奖',
		fileUrl: '/file/rongyu/教师教学能力国家级三等奖.jpg',
	}, {
		name: '教师教学能力省级一等奖',
		fileUrl: '/file/rongyu/教师教学能力省级一等奖.jpg',
	}, {
		name: '全国教师教学能力竞赛一等奖',
		fileUrl: '/file/rongyu/全国教师教学能力竞赛一等奖.jpg',
	}, {
		name: '省级教学成果奖二等奖',
		fileUrl: '/file/rongyu/省级教学成果奖二等奖.png',
	}, {
		name: '省级教学成果奖三等奖',
		fileUrl: '/file/rongyu/省级教学成果奖三等奖.jpg',
	}, {
		name: '省级教学成果奖特等奖',
		fileUrl: '/file/rongyu/省级教学成果奖特等奖.png',
	}
]